/* eslint-disable react/jsx-max-props-per-line */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import BarChartIcon from '@mui/icons-material/BarChart';
import { STATUS_LABELS, SYNC_STATUS } from './constants';

export const CHART_HEIGHT = 280;
export const CHART_HEIGHT_RANKING = 320;

export const ChartEmpty = ({ message, height = CHART_HEIGHT }) => (
  <Box
    sx={{
      height,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'text.secondary',
      gap: 1,
    }}
  >
    <BarChartIcon sx={{ fontSize: 40, opacity: 0.4 }} />
    <Typography variant="body2">{message}</Typography>
  </Box>
);

ChartEmpty.propTypes = {
  message: PropTypes.string.isRequired,
  height: PropTypes.number,
};

export const buildStatusStackedSeries = (theme) => [
  {
    dataKey: SYNC_STATUS.NOT_SYNC,
    label: STATUS_LABELS[SYNC_STATUS.NOT_SYNC],
    stack: 'total',
    color: theme.palette.info.main,
  },
  {
    dataKey: SYNC_STATUS.SYNCED,
    label: STATUS_LABELS[SYNC_STATUS.SYNCED],
    stack: 'total',
    color: theme.palette.success.main,
  },
  {
    dataKey: SYNC_STATUS.ERROR_SYNC,
    label: STATUS_LABELS[SYNC_STATUS.ERROR_SYNC],
    stack: 'total',
    color: theme.palette.error.main,
  },
];

export const mapPointsToDataset = (points) =>
  (points || []).map((point) => ({
    label: point.label,
    [SYNC_STATUS.NOT_SYNC]: point[SYNC_STATUS.NOT_SYNC] ?? 0,
    [SYNC_STATUS.SYNCED]: point[SYNC_STATUS.SYNCED] ?? 0,
    [SYNC_STATUS.ERROR_SYNC]: point[SYNC_STATUS.ERROR_SYNC] ?? 0,
  }));

export const mapRankingToDataset = (items, nameKey) =>
  (items || []).map((item) => ({
    label: item[nameKey] || '—',
    [SYNC_STATUS.NOT_SYNC]: item[SYNC_STATUS.NOT_SYNC] ?? 0,
    [SYNC_STATUS.SYNCED]: item[SYNC_STATUS.SYNCED] ?? 0,
    [SYNC_STATUS.ERROR_SYNC]: item[SYNC_STATUS.ERROR_SYNC] ?? 0,
    total: item.total ?? 0,
  }));
